<!-- Show filter if the user  -->
@if (readonly() === false || selectedPage().total > selectedPage().pageSize) {
  @if (calculateMetaData() != null) {
    <portal-filter-input
      class="elements-selector__filter"
      [calculateMetaData]="calculateMetaData()"
      [entries]="allItems()"
      [properties]="properties()"
      (changed)="filterInputChanged($event)"
    ></portal-filter-input>
  } @else {
    <portal-clear-input class="elements-selector__filter">
      <input
        class="form-control"
        [placeholder]="'common.filterInput.placeholder' | translate"
        (input)="updateFilter($any($event.target).value)"
        clearInputEl
        type="text"
      />
    </portal-clear-input>
  }
}

@if (readonly() === false) {
  @let page = availablePage();

  <portal-card [class.card--no-padding]="page.filtered > 0" classes="mb-0">
    <ng-container header>{{ elementsLabel() | translate }}</ng-container>

    @if (showHeaderActions() && readonly() === false) {
      <ng-container actions>
        <button
          class="btn btn-sm btn-outline-primary"
          [disabled]="page.filtered === 0"
          (click)="selectAllVisible()"
          type="button"
        >
          {{ 'elementsSelector.addAll' | translate }}
        </button>
      </ng-container>
    }

    <ul class="list-unstyled mb-0">
      @for (element of available(); track trackByProperty() != null ? element[trackByProperty()] : element) {
        <portal-elements-selector-item
          [callback]="selectElement"
          [element]="element"
          [elementTemplate]="elementTemplate()"
          [highlight]="element === highlightedElement()"
          icon="far fa-plus"
        ></portal-elements-selector-item>
      }

      @if (page.filtered === 0 && page.total > 0) {
        <li>{{ 'general.no.filtered.elements' | translate: { total: page.total } }}</li>
      } @else if (page.total === 0) {
        <li>{{ 'general.no.elements' | translate: { total: page.total } }}</li>
      }
    </ul>

    @if ((readonly() === false && page.filtered > 0) || page.total > page.pageSize) {
      <portal-pagination
        [page]="page"
        [simpleWithInfo]="true"
        (onPageChanged)="updateAvailablePage($event)"
        footer
      ></portal-pagination>
    }
  </portal-card>
}

<div>
  @let page = selectedPage();

  <portal-card [class.card--no-padding]="page.filtered > 0" classes="mb-0">
    <ng-container header>
      <span>
        <span>{{ selectedElementsLabel() | translate }}</span>
        <span class="badge text-bg-primary ms-1">
          {{ page?.total }}
        </span>
      </span>
    </ng-container>

    @if (showHeaderActions() && readonly() === false) {
      <ng-container actions>
        <button
          class="btn btn-sm btn-outline-primary"
          [disabled]="page.filtered === 0"
          (click)="removeAllVisible()"
          type="button"
        >
          {{ 'elementsSelector.removeAll' | translate }}
        </button>
      </ng-container>
    }

    <ul class="list-unstyled mb-0">
      @for (element of selected(); track trackByProperty() != null ? element[trackByProperty()] : element) {
        <portal-elements-selector-item
          [callback]="unselectElement"
          [element]="element"
          [elementTemplate]="elementTemplate()"
          [highlight]="element === highlightedElement()"
          [readonly]="readonly()"
          buttonPlacement="right"
          icon="far fa-minus"
        ></portal-elements-selector-item>
      }

      @if (page.filtered === 0 && page.total > 0) {
        <li>{{ 'general.no.filtered.elements' | translate: { total: page.total } }}</li>
      } @else if (page.total === 0) {
        <li>{{ 'general.no.elements' | translate: { total: page.total } }}</li>
      }
    </ul>

    @if ((readonly() === false && page.filtered > 0) || page.total > page.pageSize) {
      <portal-pagination
        [page]="page"
        [simpleWithInfo]="true"
        (onPageChanged)="updateSelectedPage($event)"
        footer
      ></portal-pagination>
    }
  </portal-card>

  <ng-content select="[below-selected]"></ng-content>
</div>
